import * as api from "app/api/templates"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./timeslots.actions"
import { handleError } from "../errorHandler/errorHandler.saga"
import { connectTemplateTimeslotsChannel } from "../templateTimeslotsChannel/templateTimeslotsChannel.actions"

export function* postTimeslots(action: actions.PostTimeslotsAction): SagaIterator {
  try {
    const { id, data } = action.payload
    yield call(api.postTimeslots, {
      data: {
        ...data,
      },
      id,
    })
    yield put(actions.postTimeslotsSuccess())
  } catch (e) {
    yield put(actions.postTimeslotsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* getTimeslots(action: actions.GetTimeslotsByIdAction): SagaIterator {
  try {
    const { id } = action.payload
    yield put(connectTemplateTimeslotsChannel({ template_id: id }))
  } catch (e) {
    yield put(actions.getTimeslotsByIdFail(e))
    yield call(handleError, { error: e })
  }
}

export function* deleteTimeslots(action: actions.DeleteTimeslotsByIdAction): SagaIterator {
  try {
    const { templateId, id } = action.payload
    yield call(api.deleteTimeslotsById, templateId, id)
    yield put(actions.deleteTimeslotsByIdSuccess())
  } catch (e) {
    yield put(actions.deleteTimeslotsByIdFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchTimeSlots(action: actions.PatchTimeslotsAction): SagaIterator {
  try {
    const { templateId, timeslot } = action.payload
    yield call(api.patchTimeslots, { timeslot, templateId })
    yield put(actions.patchTimeslotsSuccess())
  } catch (e) {
    yield put(actions.patchTimeslotsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchConflicts(action: actions.PatchConflictsAction): SagaIterator {
  try {
    const { templateId, timeslotId, conflictId, status } = action.payload
    const response = yield call(api.patchConflicts, {
      conflictId,
      status,
      templateId,
      timeslotId,
    })
    yield put(actions.patchConflictsSuccess(response?.data))
  } catch (e) {
    yield put(actions.patchConflictsFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* timeslotsSaga(): SagaIterator {
  yield takeLatest(actions.Types.POST, postTimeslots)
  yield takeLatest(actions.Types.GET_BY_ID, getTimeslots)
  yield takeLatest(actions.Types.DELETE, deleteTimeslots)
  yield takeLatest(actions.Types.PATCH, patchTimeSlots)
  yield takeLatest(actions.Types.PATCH_CONFLICTS, patchConflicts)
}
